import pageNavPerfCollect from './navigation';
import resourceCollect from './resource';

export default () => {
  resourceCollect();
  pageNavPerfCollect();
};
